import {Link} from "react-router-dom";
import React, { useState, useEffect } from "react";
import ImageUploader from "../common/ImageUploader";
import { User, firestore } from "firebase";
import isNil from "lodash/isNil";
import firebase from '../firebase';
import { ProductList } from "../vendor/ProductList";

export interface ProfileProps {
  user: User;
  profile: firebase.firestore.DocumentData;
};

export interface Product {
  id: string;
  productData: firebase.firestore.DocumentData;
};

const db = firebase.firestore();

export const Profile = ({user, profile}: ProfileProps) => {
  const [products, setProducts] = useState<Product[]>([] as Product[]);

  useEffect(() => {
    if (!isNil(user)) {
      const productQuery = db.collection("products").where('uid', '==', user.uid)
        
      productQuery.onSnapshot(snapshot => {
        const updatedProducts = snapshot.docs.map(doc => {
          return {
            id: doc.id,
            productData: doc.data(),
          };
        });
        setProducts(updatedProducts);
      });

      // detach listner
      return () => productQuery.onSnapshot(() => {})();
    }     
  }, [user]);

  return (
    <div className="vendor-home">
      <div className="brand-top content-row">
        <div className='logo-container'>
          <ImageUploader className="uploader" filePath={'brand-assets/' + user.uid + '/logo'} message='+ Upload Logo'/>
        </div>
        <div className='brand-top-meta'>
          <div className='brand-name'>{profile.name}</div>
          <div className='brand-tagline'>{profile.tag_line}</div>
        </div>
        <div className='buttons-container'>
          <Link to="/edit">
            <button className='edit-profile button'>Edit Profile</button>
          </Link>
          <Link to="/products/edit">
            <button className='button'>Add Product</button>
          </Link>
        </div>
      </div>

      <div className="brand-details content-row">
        <div className='story-container'>
          <div className='story'>{profile.story}</div>
        </div>
        <div className='sidebar'>
          <div className='sidebar-item'>City: {profile.city}</div>
          <div className='sidebar-item'>Year Founded: {profile.year}</div>
          <div className='sidebar-item'>Products: {products.length}</div>
          <div className='sidebar-item'>Annual Revenue: {profile.revenue}</div>
        </div>
      </div>

      <hr/>

      <ProductList products={products} />
    </div>
  )
};
